"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withPlugin = void 0;
const react_1 = __importDefault(require("react"));
const use_plugin_1 = require("@app/util/hooks/use-plugin");
function withPlugin(WrappedComponent) {
    return function WrappedWithPlugin(props) {
        const { isPluginEnabled, isPreventedByPlugin, togglePlugin } = (0, use_plugin_1.usePlugin)();
        return (react_1.default.createElement(WrappedComponent, { isPluginEnabled: isPluginEnabled, isPreventedByPlugin: isPreventedByPlugin, togglePlugin: togglePlugin, ...props }));
    };
}
exports.withPlugin = withPlugin;
